import { Button, Divider, Stack, Typography } from '@mui/material';
import clsx from 'clsx';
import { DialogAccessibility, DialogPrivacy, DialogTerms } from 'components/dialogs';
import { useOpen, useTranslate } from 'hooks';
import React from 'react';
import style from './index.module.scss';

export const AppFooterMain: React.FC = () => {
  const { t } = useTranslate();
  const statePrivacy = useOpen();
  const stateTerms = useOpen();
  const stateAccessibility = useOpen();

  return (
    <footer className={style.wrap}>
      <div className={clsx(style.content, 'container')}>
        <Typography variant={'body2'}>{t('copyrights')}</Typography>
        <Stack
          divider={
            <Divider
              orientation={'vertical'}
              style={{ height: '1.7rem', borderColor: '#928592' }}
            />
          }
          spacing={0.1}
          direction={'row'}
          alignItems={'center'}
          mr={'-1.1rem'}
          ml={'-1.1rem'}
        >
          <Button
            size={'small'}
            color={'secondary'}
            className={'link-style'}
            onClick={stateTerms.onOpen}
          >
            {t('terms')}
          </Button>
          <Button
            size={'small'}
            color={'secondary'}
            className={'link-style'}
            onClick={statePrivacy.onOpen}
          >
            {t('privacy')}
          </Button>
          <Button
            size={'small'}
            color={'secondary'}
            className={'link-style'}
            onClick={stateAccessibility.onOpen}
          >
            {t('accessibility')}
          </Button>
        </Stack>
        <DialogPrivacy isOpen={statePrivacy.isOpen} onClose={statePrivacy.onClose} />
        <DialogTerms isOpen={stateTerms.isOpen} onClose={stateTerms.onClose} />
        <DialogAccessibility
          isOpen={stateAccessibility.isOpen}
          onClose={stateAccessibility.onClose}
        />
      </div>
    </footer>
  );
};
